export default __webpack_public_path__ + "static/media/ruth-shafir.6c317d5e.png";